import React, { useMemo } from 'react'
import { Offcanvas } from 'react-bootstrap'

import { hideDocumentSidebar, selectDisplayedDocumentSidebar } from '../../../store/processDocument/documentSidebar'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'

import { Button } from '../../../components/Button/Button'

import { DocumentExternalUpdateSidebar } from './DocumentExternalUpdateSidebar'
import { DocumentSidebarType } from './models'

import './DocumentSidebar.scss'

export const DocumentSidebar: React.FC = () => {
  const dispatch = useAppDispatch()

  const displayedSidebar = useAppSelector(selectDisplayedDocumentSidebar)

  const SidebarBody = useMemo(() => {
    if (!displayedSidebar) {
      return null
    }

    switch (displayedSidebar.type) {
      case DocumentSidebarType.EXTERNAL_UPDATES:
        return (
          <div className='d-flex flex-column flex-grow-1 document-sidebar-content-container'>
            <DocumentExternalUpdateSidebar />
          </div>
        )
    }
  }, [displayedSidebar])

  const closeSidebar = () => {
    dispatch(hideDocumentSidebar())
  }

  return (
    <Offcanvas show={!!displayedSidebar} placement='end' className='document-sidebar-container' onHide={closeSidebar} scroll backdrop={false}>
      {displayedSidebar ? (
        <div className='h-100 py-3 pe-4 ps-3 d-flex flex-column mb-9'>
          <div className='d-flex p-4 align-items-center justify-content-between document-sidebar-header'>
            <div className='d-flex align-items-center gap-2'>
              <i className={`bi ${displayedSidebar.icon} text-white`} />
              <div className='paragraph-large bold text-white'>{displayedSidebar.title}</div>
            </div>
            <Button variant='link' onClick={closeSidebar}>
              <i className='bi bi-x-lg text-white' />
            </Button>
          </div>
          <div className='d-flex flex-column zocks-gap-2 flex-grow-1 overflow-auto'>{SidebarBody}</div>
        </div>
      ) : null}
    </Offcanvas>
  )
}
